export const environment = {
    production: true,
    UAT: false,
    Local: true, 
   // baseUrl:'http://localhost:62220/api/',
   //PnoNa135am5lVDyutCZKfd5b1spMLLWNBi6Dr9oC
  // Authorization: 'PnoNa135am5lVDyutCZKfd5b1spMLLWNBi6Dr9oC',
    AuthorizationKeys: [
    'PnoNa135am5lVDyutCZKfd5b1spMLLWNBi6Dr9oC',
    'EdRKb9nYgGiqLgiULjC5scu161r7UKHMaP6i6EDQ',
    ],
    baseURL: 'https://timesheet.aptaracorp.net/login',
    baseUrl: 'https://timesheet.aptaracorp.net/CeloxisAPI/api/',
    
};